module.exports = __webpack_public_path__ + "static/media/cineslide-2.65233c09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/img/cinema/cineslide-2.png
// module id = 585
// module chunks = 0